<template>
    <div class="layout-auth">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'LayoutAuth',
}
</script>

<style lang="scss" scoped>
    %section {
        height: 100%;
        position: relative;
        min-width: 0;
    }
    %flex {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }
    %flex-center {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    ::v-deep .layout-auth__section {
        @extend %section;
        @extend %flex;
        @extend %flex-center;
    }
    ::v-deep .layout-auth__section-container {
        width: 98%;
        max-width: 480px;
        margin-top: 140px;
    }
    ::v-deep .layout-auth__section-head {
        margin-bottom: 30px;
        text-align: center;
    }
    ::v-deep .layout-auth__section-head-title {
        font-size: 28px;
        font-weight: bold;
        line-height: 1;
    }
    ::v-deep .layout-auth__section-head-subtitle {
        color: #a7b0bd;
        margin-top: 10px;
    }
</style>